var _path, _path2, _path3, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 312.888h512v113.775H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 81.619,
  fill: "#0052b4"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M255.982 192.796l14.735 45.346h47.757l-38.65 28.028 14.849 45.481-38.691-28.16-38.63 28.108 14.79-45.429-38.616-28.028h47.722z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.748 267.286l-46.743-15.188 28.888-39.759-12.005-8.724-28.889 39.761-28.887-39.76-12.006 8.722 28.886 39.762-46.74 15.186 4.585 14.115 46.742-15.188v49.148h14.842v-49.148l46.74 15.188z"
}))));

export default SvgEt;